export var $ = window.jQuery || window.$;
//# sourceMappingURL=jquery.js.map